/* unplugin-vue-components disabled */import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/button/style/css';
import { ElEmpty as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/empty/style/css';
import { ElTable as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/table/style/css';
import { ElTableColumn as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/table-column/style/css';
import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "center"
};
var _hoisted_2 = {
  "class": "center-box"
};
var _hoisted_3 = {
  "class": "search"
};
var _hoisted_4 = {
  "class": "promise"
};
var _hoisted_5 = {
  "class": "agree"
};
var _hoisted_6 = ["checked"];
var _hoisted_7 = {
  "class": "btn_all"
};
import { certificateApi } from '@/api/member/certificateInfo';
export default /*@__PURE__*/_defineComponent({
  __name: 'Search',
  setup: function setup(__props) {
    var description = ref('对不起，没查询到相关信息！');
    var dataSource = ref([]);
    var state = ref(0);
    var formData = ref({
      name: '',
      certificateNo: ''
    });
    function search() {
      return _search.apply(this, arguments);
    }
    function _search() {
      _search = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, _res$data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(formData.value.name === '')) {
                _context.next = 3;
                break;
              }
              ElMessage.error('请输入持证人姓名');
              return _context.abrupt("return", false);
            case 3:
              if (!(formData.value.certificateNo === '')) {
                _context.next = 6;
                break;
              }
              ElMessage.error('请输入持证编号');
              return _context.abrupt("return", false);
            case 6:
              _context.next = 8;
              return certificateApi(formData.value);
            case 8:
              res = _context.sent;
              debugger;
              if (res.code === 200) {
                dataSource.value = (_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : [];
                state.value = 1;
              } else {
                ElMessage.error(res.msg);
              }
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _search.apply(this, arguments);
    }
    var checked = ref(true);
    function step() {
      state.value = 0;
    }
    return function (_ctx, _cache) {
      var _component_el_table_column = __unplugin_components_0;
      var _component_el_table = __unplugin_components_1;
      var _component_el_empty = __unplugin_components_2;
      var _component_el_button = __unplugin_components_3;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", _hoisted_2, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        "class": "content"
      }, [_createElementVNode("h2", null, "通过IIFA查询职业认证信息"), _createElementVNode("div", {
        "class": "title-content"
      }, " 本页面为IIFA China职业认证CIFA、CWA持证人员信息查询入口，仅针对中国大陆、港澳台地区的认证考生信息开放查询，其它地区的用户请联系IIFA总部或当地认证中心进行查询。 ")], -1)), _cache[5] || (_cache[5] = _createElementVNode("div", {
        "class": "search-lable"
      }, [_createElementVNode("label", null, " 持证人姓名 "), _createElementVNode("label", {
        "class": "label1"
      }, " 证书编号 ")], -1)), _createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("input", {
        placeholder: "输入持证人姓名",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _unref(formData).name = $event;
        })
      }, null, 512), [[_vModelText, _unref(formData).name]]), _withDirectives(_createElementVNode("input", {
        placeholder: "输入证书编号",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _unref(formData).certificateNo = $event;
        }),
        "class": "location"
      }, null, 512), [[_vModelText, _unref(formData).certificateNo]]), _createElementVNode("div", {
        onClick: search
      }, "Search")]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("input", {
        type: "checkbox",
        id: "agree",
        name: "agree",
        checked: _unref(checked)
      }, null, 8, _hoisted_6), _cache[2] || (_cache[2] = _createElementVNode("span", null, "我同意以下信息查询条款 ", -1))]), _cache[3] || (_cache[3] = _createElementVNode("div", {
        "class": "promiseArea"
      }, [_createTextVNode(" 使用此入口验证职业认证持有人身份，仅限于本人、用人单位、高等院校及相关合法背调单位进行资格验证，请勿他用。 "), _createElementVNode("br"), _createElementVNode("br"), _createTextVNode(" 严禁将本认证查询信息作为商业用途或出售、或公开发布，以上行为可能违反法律，IIFA China保留针对任何不当使用持证人信息的当事方采取起诉等维权措施的权利。 "), _createElementVNode("br"), _createElementVNode("br"), _createTextVNode(" 获得认证只代表学员完成相关领域课程学习，通过职业认证考试，并不代表IIFA对其推荐。 "), _createElementVNode("br")], -1))])], 512), [[_vShow, _unref(state) == 0]]), _withDirectives(_createElementVNode("div", null, [_unref(dataSource).length > 0 ? (_openBlock(), _createBlock(_component_el_table, {
        key: 0,
        data: _unref(dataSource),
        border: ""
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            prop: "egName",
            label: "英文名称"
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "中文名"
          }), _createVNode(_component_el_table_column, {
            prop: "idCard",
            label: "身份证号"
          }), _createVNode(_component_el_table_column, {
            prop: "projectName",
            label: "认证类型"
          }), _createVNode(_component_el_table_column, {
            prop: "levelName",
            label: "认证级别"
          }), _createVNode(_component_el_table_column, {
            prop: "certificateNo",
            label: "证书编号"
          }), _createVNode(_component_el_table_column, {
            prop: "sendingTime",
            label: "认证时间"
          })];
        }),
        _: 1
      }, 8, ["data"])) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        description: _unref(description)
      }, null, 8, ["description"])), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
        "class": "btn_step",
        type: "primary",
        onClick: step
      }, {
        "default": _withCtx(function () {
          return _cache[6] || (_cache[6] = [_createTextVNode("返回")]);
        }),
        _: 1
      })])], 512), [[_vShow, _unref(state) == 1]])]);
    };
  }
});